// =============================================================================
// AGENT 3 — INŻYNIER LOGIKI: GENERATOR PAYLOADU DLA WARSTWY EXPLANATION
// Przygotowuje strukturyzowany obiekt, który Agent 4 ubiera w UI.
// =============================================================================

import type { ScoreResult, AssignmentVerdict } from '../types/models';
import scenarioData from '../data/scenario.json';

export interface ExplanationPayload {
  headline: string;
  verdictSummaries: VerdictSummary[];
  aiTimeMs: number;
}

export interface VerdictSummary {
  taskId: string;
  isCorrect: boolean;
  decisionLevel: 1 | 2 | 3;
  playerPercent: number;
  explanation: string;
  playerWorkerName: string;
  aiWorkerName: string;
}

console.log("SCENARIO DATA TYPE:", typeof scenarioData, Object.keys(scenarioData || {}));
const workerNames = Object.fromEntries(
  scenarioData.workers.map((w) => [w.id, w.name])
);

/**
 * Buduje payload do przekazania komponentowi ExplanationPanel (Agent 4).
 * Symuluje, że AI podjęło decyzję w ułamku sekundy.
 */
export function buildExplanationPayload(score: ScoreResult): ExplanationPayload {
  console.log("EXPLANATION BUILDER SCORE:", JSON.stringify(score));
  const verdictSummaries: VerdictSummary[] = score.verdicts.map(
    (v: AssignmentVerdict) => ({
      taskId: v.taskId,
      isCorrect: v.decisionLevel !== 3,
      decisionLevel: v.decisionLevel,
      playerPercent: v.maxPoints > 0
        ? Math.round((v.pointsEarned / v.maxPoints) * 100)
        : 0,
      explanation: v.explanation,
      playerWorkerName: workerNames[v.playerChoice?.workerId] || 'Brak przypisania',
      aiWorkerName: workerNames[v.aiChoice?.workerId] || 'Brak przypisania',
    }),
  );

  const correctCount = verdictSummaries.filter((v) => v.isCorrect).length;

  return {
    headline: correctCount === score.verdicts.length
      ? 'Idealne dopasowanie — myślisz jak AI!'
      : `Trafiłeś ${correctCount} z ${score.verdicts.length} decyzji`,
    verdictSummaries,
    aiTimeMs: Math.floor(Math.random() * 200) + 50, // 50–250 ms — symulacja
  };
}
